import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiUpdateAppSettingsRequestBody,
  IApiUpdateAppSettingsResponseBody,
} from '../AppSettingsApi.types';
import { useApi } from '~/lib/api/useApi';
import { appQueryKeyFactory } from '../../Apps/hooks/useAppQuery';

export type IUseUpdateAppSettingsMutationValues = {
  appId: string;
  body: IApiUpdateAppSettingsRequestBody;
};

export const useUpdateAppSettingsMutation = (): UseMutationResult<
  IApiUpdateAppSettingsResponseBody,
  unknown,
  IUseUpdateAppSettingsMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values) => api.appSettings.update(values.appId, values.body),
    onSuccess: async (_, values) => {
      // TODO once the API is updated to return the updated app settings
      // queryClient.setQueryData(
      //   appSettingsQueryKeyFactory({
      //     appId: values.appId,
      //   }),
      //   updatedAppSettings,
      // );

      // In the meantime:
      await queryClient.invalidateQueries({
        queryKey: appQueryKeyFactory(values),
      });
      await queryClient.invalidateQueries({
        queryKey: appQueryKeyFactory(values),
      });
    },
  });
};
